<template>
  <div>
    <label>{{title}}
      <tooltip>
        You add multiple events (max up to 4) links like Eventbrite, Ticketmaster,
        Instagram, Facebook, Twitter, Twitch, etc. Provide insight about your event
        ticket sales, number of attendees, social proof to your event.
      </tooltip>
    </label>
    <div v-for="(link, i) in value" :key="i" class="link-container">
      <input type="url" :placeholder="placeholder"
        class="link" :value="link" @input="editLink(i, $event.target.value)"/>
      <font-awesome-icon :icon="['fa', 'minus-square']" size="1x"
        class="delete-link" @click="deleteLink(i)">
      </font-awesome-icon>
    </div>
    <button class="add-link-button" aria-label="Add Website"
      :disabled="value.length >= maxLinks"
      @click="addLink()">
      +Add {{title}}
    </button>
  </div>
</template>

<script>
export default {
  name: 'EditableLinksContainer',
  props: {
    title: {
      type: String,
      default: '',
    },
    value: {
      type: Array,
      default: () => [],
    },
    maxLinks: {
      type: Number,
      default: 5,
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  methods: {
    addLink() {
      this.value.push('');
      this.emitChange();
    },
    deleteLink(i) {
      this.value.splice(i, 1);
      this.emitChange();
    },
    editLink(i, value) {
      this.value.splice(i, 1, value);
      this.emitChange();
    },
    emitChange() {
      this.$emit('input', this.value);
    },
  },
};

</script>

<style lang="scss" scoped>
@import '@/assets/youpaired-colors.scss';

.link-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
}

.link {
  margin: 0.5rem 0;
}

.delete-link {
  color: rgb(214, 14, 14);
  cursor: pointer;
  margin-left: 0.5rem;
}

</style>
